import { FC } from 'react';
import { Box } from '@mui/material';
import PartyBalances from '../../components/Reports/PartyBalances';

/**
 * Party Balances Report Page
 * Displays opening and closing balances for all parties
 */
const PartyBalancesPage: FC = () => {
    return (
        <Box sx={{ height: '100vh', display: 'flex', flexDirection: 'column' }}>
            <PartyBalances />
        </Box>
    );
};

export default PartyBalancesPage;
